"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getExtensionFromFileName_1 = require("./utils/getExtensionFromFileName");
exports.getExtensionFromFileName = getExtensionFromFileName_1.default;
exports.getExtensionWithoutDotFromFileName = getExtensionFromFileName_1.getExtensionWithoutDotFromFileName;
var numberToByteQuantifiedStringConverter_1 = require("./utils/numberToByteQuantifiedStringConverter");
exports.numberToByteQuantifiedStringConverter = numberToByteQuantifiedStringConverter_1.default;
var isImageFile_1 = require("./utils/isImageFile");
exports.isImageFile = isImageFile_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-file-common/lib/index.js
// module id = 323
// module chunks = 0 1 11 13 24 43 84 100 106 107